"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.poolPatrol = poolPatrol;
exports.setOutOfRangePoolPatrol = setOutOfRangePoolPatrol;
exports.checkOutOfRangePoolPatrol = checkOutOfRangePoolPatrol;
exports.setInRangePoolPatrol = setInRangePoolPatrol;
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const index_js_1 = require("./index.js");
const decimal_js_1 = require("decimal.js");
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const HOLDER_CONF_TABLE_NAME = process.env.HOLDERS_CONF_TABLE_NAME;
async function poolPatrol() {
    const brokenPools = [];
    await (0, alphafi_sdk_1.getMultiCetusPool)();
    await (0, alphafi_sdk_1.getMultiInvestor)();
    await (0, alphafi_sdk_1.getMultiParentPool)();
    const price = await (0, index_js_1.getCurrentCetusPoolPrice)(false);
    const positions = await (0, index_js_1.getPositionRange)(false);
    for (const [pool, position] of positions.entries()) {
        if (!price.get(pool))
            console.error("cannot get current price for: ", pool);
        const currPrice = new decimal_js_1.Decimal(price.get(pool));
        if (currPrice.lessThan(new decimal_js_1.Decimal(position.lowerPrice)) ||
            currPrice.greaterThan(new decimal_js_1.Decimal(position.upperPrice))) {
            brokenPools.push(pool);
        }
    }
    return brokenPools.filter((pool) => alphafi_sdk_1.poolInfo[pool].retired === false);
}
async function setOutOfRangePoolPatrol(poolName) {
    const client = new client_dynamodb_1.DynamoDBClient({});
    const confTableName = HOLDER_CONF_TABLE_NAME;
    const command = new client_dynamodb_1.PutItemCommand({
        TableName: confTableName,
        Item: {
            id: { S: `${poolName}#PoolPatrol` },
            status: { S: "Out" },
            timestamp: { S: Date.now().toString() },
        },
    });
    try {
        const response = await client.send(command);
        console.log(`${poolName} out of range updated successfully: `, response);
        return response;
    }
    catch (error) {
        console.error(`Error updating ${poolName} out of range: `, error);
    }
}
async function checkOutOfRangePoolPatrol(poolName) {
    console.log("checkOutOfRangePoolPatrol poolName", poolName); //debug
    const client = new client_dynamodb_1.DynamoDBClient({});
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(client);
    const confTableName = HOLDER_CONF_TABLE_NAME;
    const params = {
        TableName: confTableName,
        Key: { id: `${poolName}#PoolPatrol` },
    };
    if (!alphafi_sdk_1.poolInfo[poolName].investorId)
        return false;
    try {
        const result = await ddbDocClient.send(new lib_dynamodb_1.GetCommand(params));
        console.log("checkOutOfRangePoolPatrol result", result); //debug
        console.log("checkOutOfRangePoolPatrol output", !!result.Item); //debug
        return !!result.Item;
    }
    catch (error) {
        console.error("Error getting item from DynamoDB:", error);
        throw new Error("Error checking if key exists");
    }
}
async function setInRangePoolPatrol(poolName) {
    const client = new client_dynamodb_1.DynamoDBClient({});
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(client);
    const confTableName = HOLDER_CONF_TABLE_NAME;
    const params = {
        TableName: confTableName,
        Key: { id: `${poolName}#PoolPatrol` },
    };
    try {
        const response = await ddbDocClient.send(new lib_dynamodb_1.DeleteCommand(params));
        console.log(`${poolName} in range updated successfully: `, response);
    }
    catch (error) {
        console.error(`Error updating ${poolName} in range: `, error);
    }
}
//# sourceMappingURL=bots.js.map